import { render, staticRenderFns } from "./selectReleaseType.vue?vue&type=template&id=08a0b87d&scoped=true"
import script from "./selectReleaseType.vue?vue&type=script&lang=js"
export * from "./selectReleaseType.vue?vue&type=script&lang=js"
import style0 from "./selectReleaseType.vue?vue&type=style&index=0&id=08a0b87d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a0b87d",
  null
  
)

export default component.exports